module.exports = __webpack_public_path__ + "static/media/kp.f6221ee3.svg";